import { useNavigate } from 'react-router-dom';
import { ChefHat } from 'lucide-react';
import { useI18n } from '../i18n';

// "Lav en opskrift": opens the recipe chat with this ingredient already chosen.
// source is "garden:<plantId>", "find:<findId>" or "catalog:<catalogId>".
export default function MakeRecipeButton({ source, className = '' }) {
  const { t } = useI18n();
  const navigate = useNavigate();
  return (
    <button type="button" data-testid="make-recipe" onClick={() => navigate(`/recipes?source=${encodeURIComponent(source)}`)}
      className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm text-white bg-gradient-to-r from-brand-green to-brand-ochre gradient-alive ${className}`}>
      <ChefHat size={16} aria-hidden="true" />{t('shed.make_recipe')}
    </button>
  );
}
